"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FraudLined = function FraudLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.029 18.363l.964-5.784a.5.5 0 00-.693-.54l-2.308 1.01V9.386l1.629-.407A.5.5 0 0020 8.493v-4a.5.5 0 00-.692-.462l-1.388.579-1-3.258a.5.5 0 00-.266-.306.5.5 0 00-.406-.006L9.372 4H5.5a.5.5 0 00-.5.5v5.485l-1.692.7a.5.5 0 00-.308.466V12.5a.5.5 0 00.621.485l1.386-.347L5 16.478a.5.5 0 00.146.354.5.5 0 00.354.147h1.514L7 17.86l-2.7 1.181a.5.5 0 00-.035.9l1.721.915L6 22.5a.5.5 0 00.5.5.5.5 0 00.5-.5l-.017-1.95a.5.5 0 00-.265-.437l-1.071-.57 14.208-6.218-.848 5.092a.5.5 0 00.12.415A4.289 4.289 0 0120 21.505a.5.5 0 001 0 5.389 5.389 0 00-.971-3.142zM10 11.5a1.5 1.5 0 01-2.87.607l2.852-.714c.003.034.018.066.018.107zM6 5h3.474a.5.5 0 00.2-.04l6.46-2.782L17 5 6 9.57zm-2 6.485l15-6.24V8.1L4 11.856zm3.879 4.643a.5.5 0 00-.357-.149H6v-1.953c.019.022.032.046.053.068A3.191 3.191 0 008.5 15c3.721 0 7.172-3.339 8.492-4.784v3.273l-8.986 3.93.016-.932a.5.5 0 00-.143-.359z",
    fill: "currentColor"
  })));
};

var _default = FraudLined;
exports["default"] = _default;